const state = {
    content: []
}

const mutations = {
    storeCatalog (state, payload) {
        state.content = payload.data
        state.content.sort((a, b) => a.position - b.position)
    },
    addCategory (state, payload) {
        state.content.unshift(payload.data)
        state.content.sort((a, b) => a.position - b.position)
    },
    updateCategory (state, payload) {
        let catIndex = state.content.findIndex(item => item.id === payload.data.id)
        state.content.filter(item => item.id !== payload.data.id)
        state.content[catIndex] = payload.data
        state.content.sort((a, b) => a.position - b.position)
    },
    changeCategoryStatus (state, payload) {
        let cat = state.content.find(item => item.id === payload.data.id)
        cat.status = payload.data.status
        cat.products.map(product => product.status = payload.data.status)
    },
    addProduct (state, payload) {
        let cat = state.content.find(item => item.id === payload.data.category_id)
        cat.products.unshift(payload.data)
    },
    updateProduct (state, payload) {
        let cat = state.content.find(item => item.id === payload.data.category_id)
        let catProd = cat.products.find(item => item.id === payload.data.id)
        catProd = payload.data
    },
    changeProductStatus (state, payload) {
        let cat = state.content.find(item => item.id === payload.data.category_id)
        let catProd = cat.products.find(item => item.id === payload.data.id)
        catProd.status = payload.data.status
    },
    deleteCategory (state, payload) {
        state.content = state.content.filter(item => item.id !== payload.id)
    },
    deleteProduct (state, payload) {
        let cat = state.content.find(item => item.id === payload.category_id)
        cat.products = cat.products.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getCatalog: state => state.content
}

export default {
    state,
    mutations,
    actions,
    getters
}
